export default "__VITE_ASSET__BWfpYod2__"